"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ifOverflowMatches = void 0;
var ifOverflowMatches = exports.ifOverflowMatches = function ifOverflowMatches(props, value) {
  var alwaysShow = props.alwaysShow;
  var ifOverflow = props.ifOverflow;
  if (alwaysShow) {
    ifOverflow = 'extendDomain';
  }
  return ifOverflow === value;
};


//////////////////
// WEBPACK FOOTER
// ./~/recharts/lib/util/IfOverflowMatches.js
// module id = 166
// module chunks = 0